import React from "react";
import { Sparkles, Pencil } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { FieldLabel, RadioCard, SectionLabel } from "./FormPrimitives";

export const CodeModeCard = ({ form, setField }) => (
  <Card className="border-zinc-200 shadow-sm">
    <div className="p-6 md:p-8">
      <SectionLabel hint="Code mode">Shipment Code</SectionLabel>
      <p className="text-sm text-zinc-700 mb-3">
        Choose <strong>Automatic</strong> (formula from answers) or <strong>Manual</strong> (type your own code — the formula is not applied).
      </p>
      <div className="grid grid-cols-2 gap-3">
        <RadioCard
          testid="radio-code-auto"
          checked={form.code_mode === "auto"}
          onClick={() => setField("code_mode", "auto")}
          icon={Sparkles}
          label="Automatic"
          sublabel="From answers + sequence"
        />
        <RadioCard
          testid="radio-code-manual"
          checked={form.code_mode === "manual"}
          onClick={() => setField("code_mode", "manual")}
          icon={Pencil}
          label="Manual"
          sublabel="Type the full code"
        />
      </div>

      {form.code_mode === "manual" && (
        <div className="mt-5">
          <FieldLabel htmlFor="manual_code">
            Manual Code <span className="text-red-600">*</span>
          </FieldLabel>
          <Input
            id="manual_code"
            data-testid="input-manual-code"
            value={form.manual_code || ""}
            onChange={(e) => setField("manual_code", e.target.value.toUpperCase())}
            placeholder="e.g. DA-T-RF-CUSTOM-1234"
            className="h-11 font-mono tracking-wider uppercase"
          />
          <p className="text-[11px] text-zinc-500 mt-1.5 font-mono">
            All other columns (customer, mode, DG, brand, etc.) are still captured normally. Only the code shown on the label is your typed value. Must be unique.
          </p>
        </div>
      )}
    </div>
  </Card>
);
